/** Labels for the delivery-preferences table, one row per notification type. */
export const TYPE_LABELS = {
  mentioned: 'Mentions',
  comment_reply: 'Comment replies',
  comment_added: 'New comments',
  file_shared: 'Files shared with me',
  member_joined: 'New members',
  workspace_invitation: 'Workspace invitations',
  system_announcement: 'Announcements',
  malware_detected: 'Malware alerts',
};

/** The bold first line of a notification in the bell and on the notifications page. */
export function titleFor(n) {
  const who = n.payload?.authorName?.trim() || 'Someone';
  if (n.type === 'mentioned') return `${who} mentioned you`;
  if (n.type === 'comment_reply') return `${who} replied to your comment`;
  if (n.type === 'comment_added') return `${who} commented`;
  if (n.type === 'signature_viewed') return `${who} viewed the document`;
  if (n.type === 'signature_signed') return `${who} signed the document`;
  if (n.type === 'signature_completed') return `${who} signed — all signatures are complete`;
  if (n.type === 'file_shared') return `${who} shared a file with you`;
  if (n.type === 'member_joined') return `${who} joined your workspace`;
  if (n.type === 'file_request_received') return `${who} uploaded a file to your file request`;
  if (n.type === 'malware_detected') {
    const count = Number(n.payload?.count ?? 1);
    return count > 1
      ? `Security alert: malware detected and blocked in ${count} files`
      : 'Security alert: malware detected and blocked';
  }
  return TYPE_LABELS[n.type] ?? 'Notification';
}
